import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useEntraUser, usePushAccess } from "@VinciDiane/core";
import ScrollRestoration from "./ScrollRestoration";

export default function RootLayout() {
  const location = useLocation();
  const { pushAccess } = usePushAccess();
  const { userData } = useEntraUser();

  useEffect(() => {
    if (userData) {
      pushAccess(location);
    }
  }, [location, userData]);

  return (
    <>
      <div className="bg-hero-section-centered-navbar fixed z-[-1] w-screen h-screen top-0 left-0"></div>
      <ScrollRestoration />
    </>
  );
}
